import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import FreePerksComponent from '../../Components/Perks/FreePerks'

const FreePerks = () => {
  const [randomboxList, setRandomboxList] = useState([])
  const [onboardingList, setOnboardingList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [randomEdit, setRandomEdit] = useState(false)

  const getPerks = async () => {
    setIsLoading(true)

    await axios
      .get(`/new/webAdmin/v2/perks`, {
        headers: {
          token: sessionStorage.getItem('token'),
        },
      })
      .then(({ data }) => {
        setRandomboxList(data.result.random)
        setOnboardingList(data.result.onboarding)
        setRandomEdit(false)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getPerks()
  }, [])

  return (
    <Wrapper>
      <FreePerksComponent
        getPerks={getPerks}
        isLoading={isLoading}
        randomboxList={randomboxList}
        onboardingList={onboardingList}
        randomEdit={randomEdit}
        setRandomEdit={setRandomEdit}
      />
    </Wrapper>
  )
}

export default FreePerks

const Wrapper = styled.div`
  width: 100%;
  height: calc(100dvh - 70px);
  overflow-y: hidden;
`
